import React from 'react';
import styles from './BookingStatusInfo.module.scss';
import { IBookingDetail } from '../../../types/Booking/booking';
import { useBookingStatusInfo } from './hooks/useBookingStatusInfo';
import { ButtonUi } from '../../ui/ButtonUi/ButtonUi';

interface BookingStatusInfoProps {
    bookingDetail: IBookingDetail;
    onAction?: () => void;
    isActionLoading?: boolean;
    onSecondaryAction?: () => void;
    isSecondaryActionLoading?: boolean;
    userType?: 'professional' | 'patient';
    reservationDateTime?: string;
}

const BookingStatusInfo: React.FC<BookingStatusInfoProps> = ({
    bookingDetail,
    onAction,
    isActionLoading,
    onSecondaryAction,
    isSecondaryActionLoading,
    userType = 'patient',
    reservationDateTime,
}) => {
    const { 
        config, 
        isVisible, 
        shouldShowAction, 
        shouldShowSecondaryAction,
        formattedMessage, 
        t 
    } = useBookingStatusInfo({
        bookingDetail,
        userType,
        reservationDateTime,
        onAction,
        onSecondaryAction
    });

    if (!isVisible || !config) return null;

    return (
        <div className={styles['status-info']}>
            <div className={styles['status-info__content']}>
                <span className={`${styles['status-info__badge']} ${styles[`status-info__badge--${config.badgeClass}`]}`}>
                    {t(config.badgeKey)}
                </span>

                <p className={styles['status-info__message']}>
                    {formattedMessage}
                </p>
            </div>

            <div className={styles['status-info__actions']}>
                {shouldShowAction && config.actionKey && (
                    <div className={styles['status-info__action']}>
                        <ButtonUi 
                            variant="contained" 
                            onClick={onAction} 
                            disabled={isActionLoading || isSecondaryActionLoading}
                            fullWidth
                        >
                            {isActionLoading ? t('bookingStatus.loading', 'Cargando...') : t(config.actionKey)}
                        </ButtonUi>
                    </div>
                )}
                {shouldShowSecondaryAction && config.secondaryActionKey && (
                    <div className={styles['status-info__action']}>
                        <ButtonUi 
                            variant="outlined" 
                            onClick={onSecondaryAction} 
                            disabled={isActionLoading || isSecondaryActionLoading}
                            fullWidth
                            style={{ marginTop: shouldShowAction ? '12px' : '0' }}
                        >
                            {isSecondaryActionLoading ? t('bookingStatus.loading', 'Cargando...') : t(config.secondaryActionKey, 'Cancelar reserva')}
                        </ButtonUi>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BookingStatusInfo;